import { createFeatureFlagSignal } from '@rma/generic/ng/feature-flags/internal';
import { FeatureFlag } from '../domain/feature-flags.enum';

export const featureFlagSignal = createFeatureFlagSignal<FeatureFlag>();
